import axios from 'axios';
import ExpressionsDetectionModel from '../../models/ExpressionsDetectionModel';
import apiService from '../apiService';

export default async function saveExpressionDetection(detection = ExpressionsDetectionModel()) {
  try {
    let _request = {
      url: `${apiService.getUrl().faceRecognition}expressionDetection/createExpressionDetection`,
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      data: {
        macAddress: detection.macAddress,
        eventId: detection.eventId,
        system: detection.system,
        scheduleId: detection.scheduleId,
        amount: detection.amount,
        neutral: detection.neutral,
        happy: detection.happy,
        sad: detection.sad,
        angry: detection.angry,
        fearful: detection.fearful,
        disgusted: detection.disgusted,
        surprised: detection.surprised,
      }
    }

    if (detection.id) {
      _request = {
        url: `${apiService.getUrl().faceRecognition}expressionDetection/updateExpressionDetection`,
        method: "PUT",
        headers: {
          "Content-Type": "application/json"
        },
        data: {
          id: detection.id,
          macAddress: detection.macAddress,
          eventId: detection.eventId,
          system: detection.system,
          scheduleId: detection.scheduleId,
          amount: detection.amount,
          neutral: detection.neutral,
          happy: detection.happy,
          sad: detection.sad,
          angry: detection.angry,
          fearful: detection.fearful,
          disgusted: detection.disgusted,
          surprised: detection.surprised,
        }
      }
    }

    const _ret = await axios(_request);

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    return ExpressionsDetectionModel(_ret.data.data);
  } catch (error) {
    console.log('Error saveExpressionDetection', error);
    throw error;
  }
}
